export const INTEGRATE_ZENDESK =
  'APP/STORES/PLATFORM_COMPONENT/CUSTOMER_SERVICE/ZENDESK/INTEGRATE'
export const INTEGRATE_ZENDESK_SUCCESS =
  'APP/STORES/PLATFORM_COMPONENT/CUSTOMER_SERVICE/ZENDESK/INTEGRATE_SUCCESS'
export const INTEGRATE_ZENDESK_ERROR =
  'APP/STORES/PLATFORM_COMPONENT/CUSTOMER_SERVICE/ZENDESK/INTEGRATE_ERROR'
